import React, { forwardRef } from 'react';

const ForwardRef = forwardRef((props, ref) => {
  return <div ref={ref} className={props.className}>{props.component}</div>;
});

export default ForwardRef;
